export default __webpack_public_path__ + "static/google-play-button-ce96ce6fa6a219f1dade2daa8752742f.svg";